import axios from "axios";
import { toast } from "react-toastify";
import { store } from "../store/storeIndex";

const axiosInstance = axios.create({
  baseURL:
    //  "http://192.168.2.146:5001",
    process.env.REACT_APP_BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer test123securetoken`,
  },
});

// Request interceptor to add auth token + user/org IDs
axiosInstance.interceptors.request.use(
  (config) => {
    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    } else {
      delete config.headers["Content-Type"];
    }

    // ✅ Get user details from Redux state
    const state = store.getState();
    console.log("state", state);
    const userId = state.authUser?.data?.data?.user_id;
    const orgId = state.authUser?.data?.data?.organization_id;

    if (userId) {
      config.headers["X-User-Id"] = userId;
    }
    if (orgId) {
      config.headers["X-Organization-Id"] = orgId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error("Response error data:", error.response.data);
      toast.error(error?.response?.data?.message);
      console.error("Response error status:", error.response.status);
      console.error("Response error headers:", error.response.headers);
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error setting up request:", error.message);
    }
    console.error("Axios error config:", error.config);
    return Promise.reject(error);
  }
);

export default axiosInstance;
